import { bindable, customElement, inject } from 'aurelia-framework';
import { CustomerViewModel } from '@dynamik/common/clients/transaction-clients';

@customElement('delete-button')
@inject(Element)
export class DeleteRender {
  constructor(private element: HTMLElement) { }

  @bindable
  params: { data: { customer: CustomerViewModel } };

  @bindable
  id: number | string;

  onDeleteClicked() {
    this.element.dispatchEvent(new CustomEvent('delete', {
      detail: { id: this.id, data: this.params.data, customer: this.params.data.customer },
      bubbles: true
    }));
  }

}

